import { TransfersProduct } from "../model";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { readIsUsedInActivePackage } from "./productDtoHelpers";

export async function getTransferById(divisionId: number, transferId: string):Promise<TransfersProduct|void> {
    const localApi = await getLocalApi();

    return await localApi.fetchSingle(apiConfig.transfers_get_by_id.replace("{divisionId}", divisionId.toString()).replace("{transferId}", transferId),
    mapTransferProduct,
    "Failed to fetch course product byId");
}

function mapTransferProduct(transferProduct: any): TransfersProduct {
    return {
        id: transferProduct.productId,
        name: transferProduct.productName,
        lastModifiedDate: transferProduct.lastModifiedDate,
        lastUpdatedBy: transferProduct.lastModifiedBy,
        lastModifiedBy: transferProduct.lastModifiedBy,
        division: transferProduct.divisionId,
        divisionText:transferProduct.division,
        divisionId: transferProduct.divisionId,
        port:transferProduct.portId, 
        portId: transferProduct.portId,
        portText:transferProduct.port,
        transferTypeText:transferProduct.transferTypeText,
        transferType: transferProduct.transferTypeId != null ? String(transferProduct.transferTypeId) : (transferProduct.transferType ?? ""),
        transferTypeId: transferProduct.transferTypeId,
        entityUpdate: transferProduct.entityUpdate,
        offeringClosureDate: transferProduct.offeringClosureDate,
        accountCategoryId: transferProduct.accountCategoryId,
        productCategoryId: transferProduct.productCategoryId,
        accountCategoryText: transferProduct.accountCategoryText,
        productCategoryText: transferProduct.productCategoryText,
        productId: transferProduct.productId,
        productName: transferProduct.productName,
        active: transferProduct.active,
        lastModifiedById: transferProduct.lastModifiedById,
        isLocked: transferProduct.isLocked ?? false,
        excludedBookingSystemIds: Array.isArray(transferProduct.excludedBookingSystemIds)
          ? transferProduct.excludedBookingSystemIds.map((id: number | string) => String(id))
          : [],
        isUsedInActivePackage: readIsUsedInActivePackage(transferProduct),
    }
}